import { updateProfile } from "action/AuthAction";
import { ProfileUpdateReq } from "domain/payload/request/profile/ProfileUpdateReq";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ProfileService from "service/ProfileService";

const EditProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { profile } = useSelector((state: any) => state.auth);
  const profileService = ProfileService();

  const [name, setName] = useState(profile?.name || "");
  const [phone, setPhone] = useState(profile?.phone || "");

  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    try {
      setIsLoadingProfile(true);
      const resp = await profileService.getProfile();

      setName(resp.data?.name || "");
      setPhone(resp.data?.phone || "");
    } catch (e) {
      console.error("Failed to load profile", e);
    } finally {
      setIsLoadingProfile(false);
    }
  };

  const handleSave = async () => {
    try {
      setIsLoadingSave(true);

      const request: ProfileUpdateReq = {
        name,
        phone,
      };

      await profileService.updateProfile(request);

      dispatch(
        updateProfile({
          name,
          phone,
        })
      );

      navigate("/profile");
    } catch (e) {
      console.error("Failed to save profile", e);
    } finally {
      setIsLoadingSave(false);
    }
  };

  return (
    <div
      className="bg-white"
      style={{
        minHeight: "100vh",
        paddingBottom: 80,
      }}
    >
      <div className="container pt-3">
        {isLoadingProfile ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" />
          </div>
        ) : (
          <>
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Name"
              style={{ height: 50 }}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            {/* PHONE (read-only) */}
            <input
              type="text"
              className="form-control mb-3 bg-light"
              placeholder="Phone"
              style={{ height: 50 }}
              value={phone}
              readOnly
            />
          </>
        )}
      </div>
      <div
        className="position-fixed bottom-0 start-0 w-100 bg-primary"
        style={{ height: 64 }}
      >
        <button
          className="btn btn-primary w-100 h-100 fw-bold"
          style={{ fontSize: 18 }}
          disabled={isLoadingSave || isLoadingProfile}
          onClick={handleSave}
        >
          {isLoadingSave ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default EditProfilePage;